import { render, staticRenderFns } from "./VerticalProgressFlow.vue?vue&type=template&id=631182aa&scoped=true&"
import script from "./VerticalProgressFlow.vue?vue&type=script&lang=js&"
export * from "./VerticalProgressFlow.vue?vue&type=script&lang=js&"
import style0 from "./VerticalProgressFlow.vue?vue&type=style&index=0&id=631182aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631182aa",
  null
  
)

export default component.exports